import Splide from "@splidejs/splide";
import Modal from "bootstrap/js/dist/modal"

window.addEventListener("DOMContentLoaded", function () {
    const imageGalleryModal = document.getElementById("imageGalleryPreview");

    if (!imageGalleryModal) return;

    document.querySelectorAll('.gallery-thumbnails-item-link').forEach((item, i) => {
        item.addEventListener('click', (e) => {
            e.preventDefault();

            const imgSlider = new Splide('.model-photo-gallery-splide', {
                perPage: 1,
                perMove: 1,
                loop: true,
                pagination: false,
                rewind: true,
                arrows: true,
                autoplay: false,
                arrowPath: "",
                start: i,
            });

            const modalEl = document.getElementById('imageGalleryPreview');
            const splideTrack = modalEl.querySelector('.splide__track');
            splideTrack.style.visibility = 'hidden';

            const myModal = new Modal(modalEl, {});

            modalEl.addEventListener('shown.bs.modal', () => {
                imgSlider.on('mounted', () => {
                    imgSlider.go(i);
                });

                imgSlider.on('ready', () => {
                    splideTrack.style.visibility = 'visible';
                });

                if (imgSlider.state.is(Splide.STATES.CREATED) || imgSlider.state.is(Splide.STATES.DESTROYED)) {
                    imgSlider.mount();
                }
            });

            myModal.show();
        })
    });
});
